import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './Services/ServiceUser/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'upload-course',
    loadChildren: () =>
      import('./ManagementCourses/upload-course/upload-course.module').then(
        (m) => m.UploadCoursePageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-courses',
    loadChildren: () =>
      import('./ManagementCourses/list-courses/list-courses.module').then(
        (m) => m.ListCoursesPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'modify-courses',
    loadChildren: () =>
      import('./ManagementCourses/modify-courses/modify-courses.module').then(
        (m) => m.ModifyCoursesPageModule,
      ),
  },
  {
    path: 'stat-courses',
    loadChildren: () =>
      import('./ManagementCourses/stat-courses/stat-courses.module').then(
        (m) => m.StatCoursesPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'detail-course',
    loadChildren: () =>
      import('./ManagementCourses/detail-course/detail-course.module').then(
        (m) => m.DetailCoursePageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'detail-replay-webinar',
    loadChildren: () =>
      import(
        './ManagementReplayWebinar/details-replay-webinar/details-replay-webinar.module'
      ).then((m) => m.DetailsReplayWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'upload-live-webinar',
    loadChildren: () =>
      import(
        './ManagementLiveWebinar/upload-live-webinar/upload-live-webinar.module'
      ).then((m) => m.UploadLiveWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'modify-live-webinar',
    loadChildren: () =>
      import(
        './ManagementLiveWebinar/modify-live-webinar/modify-live-webinar.module'
      ).then((m) => m.ModifyLiveWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-live-webinar',
    loadChildren: () =>
      import(
        './ManagementLiveWebinar/list-live-webinar/list-live-webinar.module'
      ).then((m) => m.ListLiveWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'upload-event',
    loadChildren: () =>
      import('./ManagementEvent/upload-event/upload-event.module').then(
        (m) => m.UploadEventPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-event',
    loadChildren: () =>
      import('./ManagementEvent/list-event/list-event.module').then(
        (m) => m.ListEventPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'upload-scientific-investigation',
    loadChildren: () =>
      import(
        './ManagementScientificInvestigations/upload-scientific-investigation/upload-scientific-investigation.module'
      ).then((m) => m.UploadScientificInvestigationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-scientific-investigation',
    loadChildren: () =>
      import(
        './ManagementScientificInvestigations/list-scientific-investigations/list-scientific-investigations.module'
      ).then((m) => m.ListScientificInvestigationsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'upload-replay-webinar',
    loadChildren: () =>
      import(
        './ManagementReplayWebinar/upload-replay-webinar/upload-replay-webinar.module'
      ).then((m) => m.UploadReplayWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-replay-webinar',
    loadChildren: () =>
      import(
        './ManagementReplayWebinar/list-replay-webinar/list-replay-webinar.module'
      ).then((m) => m.ListReplayWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'stat-replay-webinar',
    loadChildren: () =>
      import(
        './ManagementReplayWebinar/stat-replay-webinar/stat-replay-webinar.module'
      ).then((m) => m.StatReplayWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'profil-user',
    loadChildren: () =>
      import('./ManagementUser/profil-user/profil-user.module').then(
        (m) => m.ProfilUserPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-user',
    loadChildren: () =>
      import('./ManagementUser/list-user/list-user.module').then(
        (m) => m.ListUserPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'upload-use-case',
    loadChildren: () =>
      import('./ManagementUseCase/upload-use-case/upload-use-case.module').then(
        (m) => m.UploadUseCasePageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'list-use-case',
    loadChildren: () =>
      import('./ManagementUseCase/list-use-case/list-use-case.module').then(
        (m) => m.ListUseCasePageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'faq',
    loadChildren: () =>
      import('./ManagementUser/faq/faq.module').then((m) => m.FaqPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'accueil',
    loadChildren: () =>
      import('./accueil/accueil.module').then((m) => m.accueilPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-product',
    loadChildren: () =>
      import('./ManagementProduct/add-product/add-product.module').then(
        (m) => m.AddProductPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-specialite',
    loadChildren: () =>
      import(
        './ManagementSpecialite/add-specialite/add-specialite.module'
      ).then((m) => m.AddSpecialitePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'details-replay-webinar',
    loadChildren: () =>
      import(
        './ManagementReplayWebinar/details-replay-webinar/details-replay-webinar.module'
      ).then((m) => m.DetailsReplayWebinarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'detail-user',
    loadChildren: () =>
      import('./ManagementUser/detail-user/detail-user.module').then(
        (m) => m.DetailUserPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'uploadsafe-training',
    loadChildren: () =>
      import(
        './ManagementSafeTraining/uploadsafe-training/uploadsafe-training.module'
      ).then((m) => m.UploadsafeTrainingPageModule),
  },

  {
    path: 'modify-safe-training',
    loadChildren: () =>
      import(
        './ManagementSafeTraining/modify-safe-training/modify-safe-training.module'
      ).then((m) => m.ModifySafeTrainingPageModule),
  },
  {
    path: 'list-safe-training',
    loadChildren: () =>
      import(
        './ManagementSafeTraining/list-safe-training/list-safe-training.module'
      ).then((m) => m.ListSafeTrainingPageModule),
  },
  {
    path: 'home-training',
    loadChildren: () =>
      import(
        './ManagementSafeTraining/home-training/home-training.module'
      ).then((m) => m.HomeTrainingPageModule),
  },
  {
    path: 'detail-safe-training',
    loadChildren: () =>
      import(
        './ManagementSafeTraining/detail-safe-training/detail-safe-training.module'
      ).then((m) => m.DetailSafeTrainingPageModule),
  },
  {
    path: 'edit-event',
    loadChildren: () =>
      import('./ManagementEvent/edit-event/edit-event.module').then(
        (m) => m.EditEventPageModule,
      ),
  },
  {
    path: 'edit-use-case',
    loadChildren: () =>
      import('./ManagementUseCase/edit-use-case/edit-use-case.module').then(
        (m) => m.EditUseCasePageModule,
      ),
  },
  {
    path: 'translate-faq',
    loadChildren: () =>
      import('./ManagementUser/translate-faq/translate-faq.module').then(
        (m) => m.TranslateFaqPageModule,
      ),
  },
  {
    path: 'faq-ru',
    loadChildren: () =>
      import('./ManagementUser/faq-ru/faq-ru.module').then(
        (m) => m.FaqRuPageModule,
      ),
  },
  {
    path: 'faq-es',
    loadChildren: () =>
      import('./ManagementUser/faq-es/faq-es.module').then(
        (m) => m.FaqEsPageModule,
      ),
  },
  {
    path: 'faq-pl',
    loadChildren: () =>
      import('./ManagementUser/faq-pl/faq-pl.module').then(
        (m) => m.FaqPlPageModule,
      ),
  },
  {
    path: 'add-notice-legal',
    loadChildren: () =>
      import(
        './ManagementSetting/add-notice-legal/add-notice-legal.module'
      ).then((m) => m.AddNoticeLegalPageModule),
  },
  {
    path: 'add-privacy-policy',
    loadChildren: () =>
      import(
        './ManagementSetting/add-privacy-policy/add-privacy-policy.module'
      ).then((m) => m.AddPrivacyPolicyPageModule),
  },
  {
    path: 'add-french-noticelegal',
    loadChildren: () =>
      import(
        './ManagementSetting/add-french-noticelegal/add-french-noticelegal.module'
      ).then((m) => m.AddFrenchNoticelegalPageModule),
  },
  {
    path: 'add-english-privacy-policy',
    loadChildren: () =>
      import(
        './ManagementSetting/add-english-privacy-policy/add-english-privacy-policy.module'
      ).then((m) => m.AddEnglishPrivacyPolicyPageModule),
  },
  {
    path: 'add-russe-noticelegal',
    loadChildren: () =>
      import(
        './ManagementSetting/add-russe-noticelegal/add-russe-noticelegal.module'
      ).then((m) => m.AddRusseNoticelegalPageModule),
  },
  {
    path: 'add-russe-privacy-policy',
    loadChildren: () =>
      import(
        './ManagementSetting/add-russe-privacy-policy/add-russe-privacy-policy.module'
      ).then((m) => m.AddRussePrivacyPolicyPageModule),
  },
  {
    path: 'add-espagnol-noticelegal',
    loadChildren: () =>
      import(
        './ManagementSetting/add-espagnol-noticelegal/add-espagnol-noticelegal.module'
      ).then((m) => m.AddEspagnolNoticelegalPageModule),
  },
  {
    path: 'add-espagnol-privacy-policy',
    loadChildren: () =>
      import(
        './ManagementSetting/add-espagnol-privacy-policy/add-espagnol-privacy-policy.module'
      ).then((m) => m.AddEspagnolPrivacyPolicyPageModule),
  },
  {
    path: 'add-polonais-noticelegal',
    loadChildren: () =>
      import(
        './ManagementSetting/add-polonais-noticelegal/add-polonais-noticelegal.module'
      ).then((m) => m.AddPolonaisNoticelegalPageModule),
  },
  {
    path: 'add-polonais-privacy-policy',
    loadChildren: () =>
      import(
        './ManagementSetting/add-polonais-privacy-policy/add-polonais-privacy-policy.module'
      ).then((m) => m.AddPolonaisPrivacyPolicyPageModule),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
